import CaretLeftOutline from './CaretLeftOutline'

export default CaretLeftOutline
// eslint-disable-next-line import/export
export * from './CaretLeftOutline'
